import React, {ReactElement} from 'react';
import {IElementLineV2} from '../../../incase-domain/elements/shapes/lineV2';
import usePresScale from '../../../ui/util/usePresScale';

interface LineElementV2Props {
    element: IElementLineV2;
}

function LineElementV2({element}: LineElementV2Props): ReactElement {
    const {color, size, startPoint, endPoint} = element;
    const {transformPointFromFraction} = usePresScale();

    const stratPointTransformed = transformPointFromFraction(startPoint);
    const endPointTransformed = transformPointFromFraction(endPoint);

    return (
        <svg style={{height: '100%', width: '100%'}}>
            <line
                className="invisibleClickable"
                x1={stratPointTransformed.x}
                y1={stratPointTransformed.y}
                x2={endPointTransformed.x}
                y2={endPointTransformed.y}
                stroke="transparent"
                strokeWidth="1em"
                pointerEvents="stroke"
            />
            <line
                x1={stratPointTransformed.x}
                y1={stratPointTransformed.y}
                x2={endPointTransformed.x}
                y2={endPointTransformed.y}
                stroke={color || 'black'}
                strokeWidth={`${size || 0.0625}em`}
            />
        </svg>
    );
}

export default LineElementV2;
